var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container-alert",style:(this.styleAlert),attrs:{"role":"alert"}},[_c('span',{staticClass:"block sm:inline"},[_vm._v(_vm._s(_vm.value))]),_c('span',{staticClass:"absolute pin-b pin-r px-4 py-3"})])
}
var staticRenderFns = []

export { render, staticRenderFns }